import { useEffect, useRef, useReducer } from 'react'
import Webcam from 'react-webcam'
import { toast } from 'react-toastify'
import { initialState } from '../utilities/initialValues'
import { videoCaptureReducer } from '../utilities/videoCaptureReducer'
import { getRandomPhrase, MAX_VIDEO_SIZE } from '../utilities'

const useVideoCapture = (
    webcamRef: React.RefObject<Webcam>,
    setFormData: any
) => {
    const [state, dispatch] = useReducer(videoCaptureReducer, initialState)
    const { videoSrc, mediaRecorder, isRecording, timer, randomPhrase } = state

    useEffect(() => {
        dispatch({ type: 'SET_RANDOM_PHARSE', payload: getRandomPhrase() })
    }, [])

    useEffect(() => {
        let countdown: NodeJS.Timeout
        if (isRecording && timer > 0) {
            countdown = setInterval(() => {
                dispatch({ type: 'SET_TIMER', payload: timer - 1 })
            }, 1000)
        }

        if (timer === 0 && isRecording) {
            stopRecording()
        }

        return () => {
            clearInterval(countdown)
        }
    }, [isRecording, timer])

    const startRecording = () => {
        if (webcamRef.current) {
            const videoStream = webcamRef.current.stream
            if (videoStream) {
                const recorder = new MediaRecorder(videoStream)
                const chunks: Blob[] = []

                recorder.ondataavailable = (event) => {
                    chunks.push(event.data)
                }

                recorder.onstop = () => {
                    const blob = new Blob(chunks, { type: 'video/webm' })
                    const url = URL.createObjectURL(blob)
                    dispatch({ type: 'SET_VIDEO_SOURCE', payload: url })

                    if (blob.size > MAX_VIDEO_SIZE) {
                        toast.info('حجم ویدیو بیشتر از ۵ مگابایت است')
                        dispatch({ type: 'SET_VIDEO_SOURCE', payload: null })
                    } else {
                        setFormData((prevData: any) => ({
                            ...prevData,
                            video: blob,
                        }))
                    }
                }

                recorder.start()
                dispatch({ type: 'SET_MEDIA_RECORDER', payload: recorder })
                dispatch({ type: 'SET_IS_RECORDING', payload: true })
                dispatch({ type: 'SET_TIMER', payload: 6 })
            } else {
                console.error('No video stream available')
                toast.error('دسترسی به وب کم ناموفق بود')
            }
        }
    }

    const stopRecording = () => {
        if (mediaRecorder) {
            mediaRecorder.stop()
            dispatch({ type: 'SET_IS_RECORDING', payload: false })
            dispatch({ type: 'SET_TIMER', payload: 6 })
        }
    }

    return {
        videoSrc,
        isRecording,
        timer,
        randomPhrase,
        startRecording,
        stopRecording,
        dispatch,
    }
}

export default useVideoCapture
